#import "../fragments/account-info-fragment.graphql"

query GetAccountInfo($id: ID!) {
    account(id: $id) {
        ...AccountInfoFragment
    }
}
